import { type OrderLookupStartResponse, orderLookupV1Start } from '@/api/generated';
import { formatDobForApi } from '@/lib/formatters';

import { createRateLimitedResendMutation } from './create-rate-limited-resend-mutation';

type MutationParams = {
  firstName: string;
  lastName: string;
  dob: string;
  recipient: 'me' | 'someone-else';
};

const fetcher = async (params: MutationParams) => {
  const { data } = await orderLookupV1Start({
    body: {
      first_name: params.firstName,
      last_name: params.lastName,
      dob: formatDobForApi(params.dob),
      who: params.recipient === 'someone-else' ? 'someone_else' : 'me',
    },
  });

  return data;
};

export const useOrderLookupStartMutation = createRateLimitedResendMutation<
  MutationParams,
  OrderLookupStartResponse
>({
  fetcher,
  errorMessage: 'Failed to start order lookup',
  storeName: 'order-lookup-rate-limiter',
  limit: 1,
});
